<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M19.2617 9.75C19.2617 7.95979 18.5506 6.2429 17.2847 4.97703C16.0188 3.71116 14.3019 3 12.5117 3C10.7215 3 9.00462 3.71116 7.73875 4.97703C6.47288 6.2429 5.76172 7.95979 5.76172 9.75C5.76172 12.519 7.97722 16.128 12.5117 20.451C17.0462 16.128 19.2617 12.519 19.2617 9.75ZM12.5117 22.5C7.01122 17.5005 4.26172 13.2495 4.26172 9.75C4.26172 7.56196 5.13091 5.46354 6.67809 3.91637C8.22526 2.36919 10.3237 1.5 12.5117 1.5C14.6998 1.5 16.7982 2.36919 18.3454 3.91637C19.8925 5.46354 20.7617 7.56196 20.7617 9.75C20.7617 13.2495 18.0122 17.5005 12.5117 22.5Z"
      fill="#213E7A"
    />
    <path
      d="M12.5117 12C13.1085 12 13.6808 11.7629 14.1027 11.341C14.5247 10.919 14.7617 10.3467 14.7617 9.75C14.7617 9.15326 14.5247 8.58097 14.1027 8.15901C13.6808 7.73705 13.1085 7.5 12.5117 7.5C11.915 7.5 11.3427 7.73705 10.9207 8.15901C10.4988 8.58097 10.2617 9.15326 10.2617 9.75C10.2617 10.3467 10.4988 10.919 10.9207 11.341C11.3427 11.7629 11.915 12 12.5117 12ZM12.5117 13.5C11.5172 13.5 10.5633 13.1049 9.86007 12.4017C9.15681 11.6984 8.76172 10.7446 8.76172 9.75C8.76172 8.75544 9.15681 7.80161 9.86007 7.09835C10.5633 6.39509 11.5172 6 12.5117 6C13.5063 6 14.4601 6.39509 15.1634 7.09835C15.8666 7.80161 16.2617 8.75544 16.2617 9.75C16.2617 10.7446 15.8666 11.6984 15.1634 12.4017C14.4601 13.1049 13.5063 13.5 12.5117 13.5Z"
      fill="#213E7A"
    />
  </svg>
</template>

<script>
export default {
  name: "IconLocation",
};
</script>

<style></style>
